import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NotifymodalComponent } from '../notifymodal/notifymodal.component';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    let logged = localStorage.getItem('personelInfo') !== null;
    //let isPass =JSON.parse(localStorage.getItem('personelInfo')).first_login == "True";; //this.authService.isPassChanged();


    if (logged) {
      //this.alertify.error();
      //console.log(localStorage.getItem('personelInfo'));
      if (JSON.parse(localStorage.getItem('personelInfo')).first_login == "True") {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: true,
            text: "İşlem yapmadan önce şifrenizi değiştirmelisiniz !",
            subject: "First Login"
          }
        }).afterClosed().subscribe(() => {
          return false;
        });
      }

      return true;
    }

    if (!logged) {
      this.dialog.open(NotifymodalComponent, {
        data: {
          isSuccess: false,
          text: "Sayfaya erişim için sisteme giriş yapmalısınız!",
          subject: "Login Guard"
        }
      }).afterClosed().subscribe(() => {
        return false;
      });
      //this.alertify.error("Sayfaya erişim için sisteme giriş yapmalısınız!");


    }






  }

}
